import { logout } from 'app/redux/actions/auth';
import { BACKUP, Backup, RESTORE, Restore } from 'app/redux/actions/persistence';

import {
  SWITCH_ONE_CLICK_BET_ACTIVE_STATE,
  SWITCH_SETTINGS_SELECT,
  SWITCH_TO_ALLOW_PRICE_PREFERENCE,
  SwitchOneClickBetActiveState,
  SwitchSettingsSelect,
  SwitchToAllowPricePreference,
} from '../actions/preferences';
import { AllowingPricePreference } from '../constants';
import { PreferencesState } from '../types/preferences';

// ---

const initialState: PreferencesState = {
  oneClickBetActive: false,
  settingsActive: false,
  allowPricePreference: AllowingPricePreference.NOTHING,
};

// TODO описать LOGOUT_SUCCESS, когда он будет переведен на .ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PayloadType = any;

type RestoredKeys = 'allowPricePreference';
type RestoreAction = Restore<Pick<PreferencesState, RestoredKeys>>;

export type PreferencesActions =
  | Backup
  | RestoreAction
  | SwitchOneClickBetActiveState
  | SwitchSettingsSelect
  | SwitchToAllowPricePreference
  | PayloadType;

// ---

function handleRestore(
  state: PreferencesState,
  payload: RestoreAction['payload'],
): PreferencesState {
  const data = {
    allowPricePreference: state.allowPricePreference,
  };
  if ('allowPricePreference' in payload) {
    data.allowPricePreference = payload.allowPricePreference;
  }

  return { ...state, ...data };
}

// ---

export default function (
  state = initialState,
  action: PreferencesActions,
): PreferencesState {
  switch (action.type) {
    case BACKUP:
      return {
        allowPricePreference: state.allowPricePreference,
      } as PreferencesState;

    case RESTORE:
      return handleRestore(state, action.payload);

    case SWITCH_ONE_CLICK_BET_ACTIVE_STATE:
      return {
        ...state,
        oneClickBetActive: action.payload.value,
      };

    case SWITCH_SETTINGS_SELECT:
      return {
        ...state,
        settingsActive: action.payload.value,
      };

    case SWITCH_TO_ALLOW_PRICE_PREFERENCE:
      return {
        ...state,
        allowPricePreference: action.payload.value,
      };

    case logout.fulfilled.toString():
      return initialState;

    default:
      return state;
  }
}
